const condoSec1_Object = (payload) => {
  return {
    type: "condoSec1",
    payload,
  };
};

export default condoSec1_Object;
